var months = [ 'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec' ]

var simulator = {
  methods: {
    balanceHelper (simulation) {
      var days = { jan: 31, feb: 28, mar: 31, apr: 30, may: 31, jun: 30, jul: 30, aug: 31, sep: 30, oct: 31, nov: 30, dec: 31 }

      var biomass = {
        jan: [ 92.7, 30, 6, 275 ],
        feb: [ 193.95, 220, 45.6, 550 ],
        mar: [ 543.15, 228, 45.6, 1100 ],
        apr: [ 317.25, 211.6, 45.6, 1925 ],
        may: [ 227.7, 423.2, 45, 1650 ],
        jun: [ 231.3, 307.6, 44, 1595 ],
        jul: [ 234.9, 187.6, 15, 1375 ],
        aug: [ 53.2, 87.6, 4.5, 900 ],
        sep: [ 55.4, 40.5, 4, 675 ],
        oct: [ 50.4, 30.3, 3.5, 450 ],
        nov: [ 65.8, 55.8, 3, 405 ],
        dec: [ 87.5, 55.8, 2.5, 382.5 ]
      }

      var type = [ 'high', 'middle', 'low', 'buffel' ]

      var pasture = {}

      var month, sum

      for (var i = 0; i < months.length; i++) {
        month = months[i]

        sum = 0
        for (var j = 0; j < type.length; j++) {
          sum += simulation[ 'pasture_' + type[j] ] * biomass[ month ][j]
        }

        pasture[ month ] = sum
      }

      var pv = {
        goats_meat: [ 3.5, 3, 3.2 ],
        goats_milk: [ 4.5, 3, 3.2 ],
        cattl_meat: [ 3.5, 2, 2.9 ],
        cattl_milk: [ 3.5, 2.5, 2.9 ],
        sheep_meat: [ 3.1, 2.3, 2.9 ]
      }

      var races = [ 'goats_meat', 'goats_milk', 'cattl_meat', 'cattl_milk', 'sheep_meat' ]

      var category = [ 'matrizes', 'reprodutores', 'jovens' ]

      var daily = {}

      for (var y = 0; y < races.length; y++) {
        for (var z = 0; z < category.length; z++) {
          daily[ races[y] + '_' + category[z] ] = Math.round((
            simulation[ races[y] + '_' + category[z] ] *
            simulation[ races[y] + '_' + category[z] + '_weight' ] *
            pv[ races[y] ][z]) / 100)
        }
      }

      var consumption = {}

      for (var m = 0; m < months.length; m++) {
        month = months[m]

        consumption[ month ] = 0

        for (var w = 0; w < races.length; w++) {
          for (var x = 0; x < category.length; x++) {
            consumption[ month ] += daily[ races[w] + '_' + category[x] ] * days[ month ]
          }
        }
      }

      var balance = {}

      for (var n = 0; n < months.length; n++) {
        balance[ months[n] ] = Math.round(pasture[ months[n] ] - consumption[ months[n] ])
      }

      return balance
    },
    sourceHelper (simulation) {
      return 0.10 * simulation.source_palma + 0.30 * simulation.source_silagem + 0.35 * simulation.source_capineira + 0.90 * simulation.source_feno
    },
    finalStatsHelper (balance, source) {
      var stats = {}

      stats.lower = balance[ months[0] ]
      stats.critical = 0

      for (var m = 0; m < months.length; m++) {
        if (balance[ months[m] ] < stats.lower) {
          stats.lower = balance[ months[m] ]
        }

        if (balance[ months[m] ] < 0) {
          stats.critical += balance[ months[m] ]
        }
      }

      stats.final = stats.critical + source

      return stats
    }
  }
}

export default simulator
